// extracted by mini-css-extract-plugin
export var noSpinners = "_o7-6";
export var percentageInput = "_o7-7";
export var variantColor1 = "_o7-0";
export var variantColor2 = "_o7-1";
export var variantColor3 = "_o7-2";
export var variantColor4 = "_o7-3";
export var variantColor5 = "_o7-4";
export var variantColor6 = "_o7-5";